<template>
  <!-- Loading -->
  <div class="vld-parent">
      <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128" />
  </div>

  <div class="shadow overflow-hidden">
    <div>
      <dl>
        <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('employee.startYear') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ work.startyear }}
          </dd>
        </div>

        <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('employee.endYear') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ work.endyear }}
          </dd>
        </div>

        <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('employee.place') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ work.place }}
          </dd>
        </div>

        <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('employee.position') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ work.position }}
          </dd>
        </div>

        <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('employee.salary') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ work.salary }}
          </dd>
        </div>

        <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('vaccines.description') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ work.remarks }}
          </dd>
        </div>

        <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-1 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            <a class="bg-blue-700 hover:bg-blue-700 text-white font-bold py-2 px-4" :href="work.filename" download="working.pdf">
              Working Download
            </a>
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            <vue-pdf-embed :source="pdfSource" />
          </dd>
        </div>

      </dl>

    </div>

  </div>

</template>
<script>
/* eslint-disable */
import { ref, reactive, watchEffect } from 'vue'
import { axiosDocument } from "@/boot/axios";
import VuePdfEmbed from 'vue-pdf-embed'
import Loading from 'vue-loading-overlay'
export default {
  name: 'ClassForm',
  components: {
    Loading,
    VuePdfEmbed
  },
  props: {
    propObject: {
        type: Object,
        default: () => ({ empty: true })
    }
  },
  data: function () {
    return {
    }
  },
  emits: ['close-modal', 'submit'],
  setup (props, { emit }) {
    const titleStack = ref(['Admin', 'Forms'])

    const work = ref({})
    const isLoading = ref(false)

    // if doc academic active = true
    const storeDoc = (env) => {
        const url = 'doc-file-getEmployee'
        const method = 'POST'

        isLoading.value = true
        const paramsData = { id: env }

        const jsonData = JSON.stringify(paramsData)
        console.log('paramsData DOC', paramsData)

        const configHeaders = {
            'content-type': 'application/json',
            Accept: 'application/json'
        }

        axiosDocument({
            method,
            url,
            data: jsonData,
            headers: configHeaders
        })
        .then(response => {
            isLoading.value = false
            pdfSource.value = response.data.data
            console.log('pdfSource.value', pdfSource.value)
        })
        .catch(error => {
            isLoading.value = false
            console.log('error', error)
        })
    }

    const pdfSource = ref(null)
    watchEffect(() => {
      work.value = props.propObject

      if (work.value && work.value.filename) {
        pdfSource.value = work.value.filename
      }
      
      if(work.value && work.value.is_doc > 0){
        storeDoc(work.value.id)
      }
    })

    return {
      isLoading,
      storeDoc,
      titleStack,
      work,
      pdfSource

    }
  }
}
</script>